import {
  getCheckoutFormValues,
  getCheckoutInsurantData,
  getQuotation,
  getIsOperatorFromSelector,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';
import { FormsEnum, MessagesEnum } from 'app/shared/enums';
import { checkIsDataObfuscated } from 'app/services/businessFunctions/helpers/checkIsDataObfuscated';
import { handleObfuscatedFieldConsentReset } from 'app/services/businessFunctions/helpers/handleObfuscatedFieldConsentReset';

const insurantObfuscation = {
  showInsurantNameObfuscatedMessage(initialRun?: boolean) {
    const { name } = getCheckoutInsurantData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: name || '',
      initialRun,
      messageKey: MessagesEnum.InsurantNameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'different',
        field: 'name',
      },
    });
  },
  showInsurantLastNameObfuscatedMessage(initialRun?: boolean) {
    const { lastName } = getCheckoutInsurantData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: lastName || '',
      initialRun,
      messageKey: MessagesEnum.InsurantLastNameObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'different',
        field: 'lastName',
      },
    });
  },
  showInsurantPhoneNumberObfuscatedMessage(initialRun?: boolean) {
    const { phoneNumber } = getCheckoutFormValues();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();

    handleObfuscatedFieldConsentReset({
      value: phoneNumber || '',
      initialRun,
      messageKey: MessagesEnum.InsurantPhoneNumberObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'root',
        field: 'phoneNumber',
      },
    });
  },
  showCheckoutInsurantEmailObfuscatedMessage(initialRun?: boolean) {
    const { emailAddress } = getCheckoutFormValues();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: emailAddress || '',
      initialRun,
      messageKey: MessagesEnum.InsurantEmailObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'root',
        field: 'email',
      },
    });
  },
  showInsurantPeselObfuscatedMessage(initialRun?: boolean) {
    const { peselNumber } = getCheckoutInsurantData();
    const quotation = getQuotation();
    const isOperator = getIsOperatorFromSelector();
    handleObfuscatedFieldConsentReset({
      value: peselNumber?.toString() || '',
      initialRun,
      messageKey: MessagesEnum.InsurantPeselObfuscated,
      formName: FormsEnum.CheckoutForm,
      quotation,
      isOperator,
      resetTarget: {
        type: 'person',
        trackedPerson: 'different',
        field: 'peselNumber',
      },
    });
  },
  showInsurantHomeAddressStreetNameObfuscatedMessage(initialRun?: boolean) {
    const { homeAddress } = getCheckoutInsurantData();

    const showObfuscatedMessage = checkIsDataObfuscated(
      homeAddress?.streetName,
      initialRun
    );
    setMessageVisibility({
      key: MessagesEnum.InsurantHomeAddressStreetNameObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showInsurantPassportObfuscatedMessage(initialRun?: boolean) {
    const { passport } = getCheckoutInsurantData();

    const showObfuscatedMessage = checkIsDataObfuscated(passport, initialRun);

    setMessageVisibility({
      key: MessagesEnum.InsurantPassportObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showInsurantAdditionalPhoneNumberObfuscatedMessage(initialRun?: boolean) {
    const { additionalPhoneNumber } = getCheckoutFormValues();

    const showObfuscatedMessage = checkIsDataObfuscated(
      additionalPhoneNumber,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.InsurantAdditionalPhoneNumberObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
  showCheckoutInsurantAdditionalEmailObfuscatedMessage(initialRun?: boolean) {
    const { additionalEmailAddress } = getCheckoutFormValues();

    const showObfuscatedMessage = checkIsDataObfuscated(
      additionalEmailAddress,
      initialRun
    );

    setMessageVisibility({
      key: MessagesEnum.InsurantAdditionalEmailObfuscated,
      visible: showObfuscatedMessage,
      formName: FormsEnum.CheckoutForm,
    });
  },
};

export default insurantObfuscation;
